import type { InterpretationSnapshotCreateRequest } from '../redux';

export type InterpretationSnapshotCaptureHandle = {
  isReady: () => boolean;
  shouldCapture: () => boolean;
  prepare: () => Promise<InterpretationSnapshotCreateRequest | null>;
  persist: (
    snapshotRequest: InterpretationSnapshotCreateRequest,
  ) => Promise<boolean>;
};

let activeCaptureHandle: InterpretationSnapshotCaptureHandle | null = null;

export const registerInterpretationSnapshotCapture = (
  handle: InterpretationSnapshotCaptureHandle,
) => {
  activeCaptureHandle = handle;

  return () => {
    if (activeCaptureHandle === handle) {
      activeCaptureHandle = null;
    }
  };
};

export const getInterpretationSnapshotCapture = () => activeCaptureHandle;
